

import React, { useRef } from "react";
import Table from "react-bootstrap/Table";
import { Line } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Import images for PDF header and footer (adjust paths as needed)

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const AeroTable21 = ({ data }) => {
  const pdfRef = useRef(); // Reference for PDF capture

  // Extract years from the data
  const years = ["2018", "2019", "2020", "2021", "2022", "2023", "2024"];

  // Prepare data for the chart
  const chartData = {
    labels: years,
    datasets: data.map((item) => ({
      label: item.sex_label,
      data: years.map((year) => parseFloat(item[`year_${year}`]) || 0),
      borderColor:
        item.sex_label === "Female"
          ? "rgb(255, 99, 132)"
          : item.sex_label === "Male"
            ? "rgb(54, 162, 235)"
            : "rgb(75, 192, 192)",
      backgroundColor:
        item.sex_label === "Female"
          ? "rgba(255, 99, 132, 0.2)"
          : item.sex_label === "Male"
            ? "rgba(54, 162, 235, 0.2)"
            : "rgba(75, 192, 192, 0.2)",
      tension: 0.4,
      fill: true,
    })),
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: window.innerWidth < 768 ? 10 : 12
          },
          boxWidth: 20,
          padding: 15,
          usePointStyle: true
        }
      },
      title: {
        display: true,
        text: "High School Employment by Year (2018-2024)",
        font: {
          size: window.innerWidth < 768 ? 14 : 16,
          weight: 'bold'
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Employees",
          font: {
            size: window.innerWidth < 768 ? 12 : 14,
            weight: 'bold'
          }
        },
        grid: {
          display: true
        },
        ticks: {
          font: {
            size: window.innerWidth < 768 ? 10 : 12
          }
        }
      },
      x: {
        title: {
          display: true,
          text: "Year",
          font: {
            size: window.innerWidth < 768 ? 12 : 14,
            weight: 'bold'
          }
        },
        grid: {
          display: true
        },
        ticks: {
          font: {
            size: window.innerWidth < 768 ? 10 : 12
          }
        }
      },
    },
  };

  // Function to download PDF
  const downloadPDF = () => {
    const input = pdfRef.current;
    input.style.width = "1100px"; // Expand width for better PDF capture

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);
      pdf.line(10, 35, 200, 35);

      // Main Content
      pdf.addImage(imgData, "PNG", 5, 38, imgWidth, imgHeight);

      // Footer
      pdf.line(10, 260, 200, 260);
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.setFontSize(10);
      pdf.text("Built by", 55, 275);
      pdf.addImage(bodex, "PNG", 68, 269, 44, 10);
      pdf.text("using", 112, 275);
      pdf.addImage(kpi, "PNG", 125, 265, 20, 20);
      pdf.text(" 20250916.v3.198", 148, 275);
      const currentDate = new Date().toLocaleDateString();
      pdf.text(`Downloaded on: ${currentDate}`, 150, 295);
      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("high-school-employment-trend.pdf");
      input.style.width = ""; // Reset width
    });
  };

  return (
    <div className="container">
      <div ref={pdfRef} className="content-to-export">
        <h3 className="mt-3">High School Employment by Year (2018-2024)</h3>

        {/* Table Section */}
        <Table striped bordered hover responsive className="mb-4 bg-white">
          <thead>
            <tr>
              <th>Sex</th>
              <th>2018</th>
              <th>2019</th>
              <th>2020</th>
              <th>2021</th>
              <th>2022</th>
              <th>2023</th>
              <th>2024</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.sex_label}</td>
                <td>{item.year_2018}</td>
                <td>{item.year_2019}</td>
                <td>{item.year_2020}</td>
                <td>{item.year_2021}</td>
                <td>{item.year_2022}</td>
                <td>{item.year_2023}</td>
                <td>{item.year_2024}</td>
              </tr>
            ))}
          </tbody>
        </Table>

      

        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            margin: "auto",
            overflowX: "auto",
          }}
          className="chart-container"
        >
          {" "}
          <div
            style={{
              width: "100%",
              minWidth: "500px", // Reasonable minimum width
              height: "400px",
              background: "#fff",
            }}
            className="chart-wrapper"
          >
            <Line data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>

      {/* Download PDF Button */}
      <div className="flex justify-center mt-4">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF</span>
          <span>
            <img className="w-[2rem]" src={pdf} alt="PDF Icon" />
          </span>
        </button>
      </div>
    </div>
  );
};

export default AeroTable21;
